<template>
  <div>
    <div class="status-cards-container">
      <div class="kpi-card-wrapper">
        <status-summary-card
          stateName="Conductores Asignados"
          color="var(--primary)"
          icon="people"
          :mainValue="driverCount"
          unit=""
        />
      </div>
      <div class="kpi-card-wrapper">
        <status-summary-card
          stateName="Paquetes Promedio/Conductor"
          color="var(--secondary)"
          icon="inventory_2"
          :mainValue="averagePackages"
          unit=" paq."
        />
      </div>
      <div class="status-card-wrapper">
        <status-summary-card
          stateName="En Tránsito"
          color="var(--status-in-transit)"
          icon="local_shipping"
          :mainValue="statusStats['in-transit'].percentage"
          unit="%"
          :subLabel="`${statusStats['in-transit'].count} total`"
        />
      </div>
      <div class="status-card-wrapper">
        <status-summary-card
          stateName="Entregados"
          color="var(--status-approved)"
          icon="inventory"
          :mainValue="statusStats.approved.percentage"
          unit="%"
          :subLabel="`${statusStats.approved.count} total`"
        />
      </div>
      <div class="status-card-wrapper">
        <status-summary-card
          stateName="Pendientes"
          color="var(--status-partial)"
          icon="block"
          :mainValue="statusStats.partial.percentage"
          unit="%"
          :subLabel="`${statusStats.partial.count} total`"
        />
      </div>
      <div class="status-card-wrapper">
        <status-summary-card
          stateName="Reprogramados"
          color="var(--status-rescheduled)"
          icon="event"
          :mainValue="statusStats.rescheduled.percentage"
          unit="%"
          :subLabel="`${statusStats.rescheduled.count} total`"
        />
      </div>
      <div class="status-card-wrapper">
        <status-summary-card
          stateName="Rechazados"
          color="var(--status-rejected)"
          icon="thumb_down"
          :mainValue="statusStats.rejected.percentage"
          unit="%"
          :subLabel="`${statusStats.rejected.count} total`"
        />
      </div>
      <div class="status-card-wrapper">
        <status-summary-card
          stateName="Cancelados"
          color="var(--status-cancelled)"
          icon="delete"
          :mainValue="statusStats.cancelled.percentage"
          unit="%"
          :subLabel="`${statusStats.cancelled.count} total`"
        />
      </div>
      <div class="status-card-wrapper">
        <status-summary-card
          stateName="Total"
          color="var(--secondary)"
          icon="summarize"
          :mainValue="statusStats.total"
          unit=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import StatusSummaryCard from '../UI/StatusSummaryCard.vue'

export default {
  name: 'ManagementControlCards',
  components: {
    StatusSummaryCard
  },
  props: {
    driverCount: {
      type: Number,
      default: 0
    },
    averagePackages: {
      type: Number,
      default: 0
    },
    statusStats: {
      type: Object,
      default: () => ({
        'in-transit': { count: 0, percentage: 0 },
        approved:     { count: 0, percentage: 0 },
        partial:      { count: 0, percentage: 0 },
        rescheduled:  { count: 0, percentage: 0 },
        rejected:     { count: 0, percentage: 0 },
        cancelled:    { count: 0, percentage: 0 },
        total:        0
      })
      }
    }
}
</script>

<style scoped>
.kpi-cards-container {
  display: grid;
  grid-template-columns: repeat(4, minmax(200px, 1fr));
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.status-cards-container {
  display: grid;
  grid-template-columns: repeat(9, minmax(140px, 1fr));
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

@media (max-width: 1200px) {
  .status-cards-container {
    grid-template-columns: repeat(3, minmax(140px, 1fr));
  }
}

@media (max-width: 768px) {
  .kpi-cards-container {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
  }
  .status-cards-container {
    grid-template-columns: repeat(2, minmax(140px, 1fr));
  }
}

.kpi-card-wrapper,
.status-card-wrapper {
  display: flex;
  flex-direction: column;
}
</style>
